<div>
  <label class="text-uppercase input-label" for="{{inputId}}" *ngIf="label !== null">
    {{label}} <span class="text-danger" *ngIf="required">*</span>
  </label>
  <input #input type="{{inputType}}"
         class="form-control wfm-form-control"
         [value]="textValue"
         [attr.required]="required ? null : ''"
         [attr.autocomplete]="wfmAutoComplete==='off'?'one-time-code':''"
         [attr.placeholder]="placeHolder"
         (input)="updateValue($event)"
         (blur)="onBlur($event)"
         (focus)="onFocus($event)"
         [attr.name]="inputName"
         [ngStyle]="inlineStyleObject"
         [ngClass]="{'invalid-input': hasErrorMsg(), 'valid-input': !hasErrorMsg() && !untouched, 'text-right': inputType === 'number'}"
         id="{{inputId}}"
         [attr.maxlength]="maxLength"
         [attr.min]="inputType === 'number' ? minValue : null"
         [attr.max]="inputType === 'number' ? maxValue : null"
  >
  <div id="wfmtext-error" class="invalid-feedback" [attr.data-component]="'#' + inputId"
       [ngClass]="{'show-error': hasErrorMsg()}">
    <ul *ngIf="showMultilineError">
      <li *ngFor="let msg of serverSideErrMsgs">
        <span class="error-message">{{msg}}</span>
      </li>
      <li *ngFor="let msg of clientSideErrMsgs">
        <span class="error-message">{{msg}}</span>
      </li>
    </ul>
    <div *ngIf="!showMultilineError"><span class="error-message">{{getSingleError()}}</span>
    </div>
  </div>
</div>
